import React from "react";
import "./ErrorPage.css";
import { Link } from "react-router-dom";
import { ReactComponent as NotFoundSVG } from "../../images/page-not-found.svg";
import Title from "../../components/Title/Title";

const ErrorPage = () => {
  return (
    <div className="error-container">
      <div className="mb-8"></div>
      <Title title="The page you look does not exist" />
      <div className="mb-2"></div>
      <Link to="/">
        <div className="center-button">
          <button className="backtohome">&#60; Back to Home</button>
        </div>
      </Link>
      <div className="error-icons">
        <div className="flex-1">
          <NotFoundSVG className="error-icon" />
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
